<script>
  export let fill;
</script>

<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill={fill || "rgba(255,255,255,0.8)"}
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M29.6708 16.8964C28.3942 20.0631 26.3712 21.9552 24.692 23.5042C23.2799 24.812 21.0426 26.598 17.8715 28.1484C16.9021 28.6224 15.7679 28.6224 14.7985 28.1484C11.6274 26.598 9.3901 24.812 7.97803 23.5042C6.29879 21.9552 4.27583 20.0631 2.99921 16.8964C2.49838 15.6611 1.88953 14.1023 2.01719 12.0239C2.06629 11.2396 2.29216 7.70037 5.26767 5.5141C6.0631 4.92587 8.0566 3.71019 10.6688 4.06313C13.3567 4.42327 15.0256 6.23309 15.8113 7.3419C16.0493 7.67783 16.6207 7.67783 16.8587 7.3419C17.6444 6.23309 19.3133 4.42327 22.0012 4.06313C24.6134 3.71019 26.6069 4.92587 27.4023 5.5141C30.3778 7.70037 30.6037 11.2396 30.6528 12.0239C30.7805 14.1023 30.1716 15.6611 29.6708 16.8964Z"
  />
</svg>
